import { collectionEngineV1 } from '../apis.js';
const queueAPI = collectionEngineV1('/queue', false);
export const getProgress = (listHandlerId) => queueAPI('GET', `/list-handler-progress/${listHandlerId}`);
//# sourceMappingURL=queue.js.map